export default "<div class=\"text-digital-red\">\r\n  <h2>Error</h2>\r\n  <p>There was a problem submitting the form, please try again later.</p>\r\n</div>";